import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Select from 'react-select';
import forms from 'constants/forms';
import AutoCompleteDoctor from 'components/molecules/autocompleteFilter/doctor';
import AutoCompleteClinics from 'components/molecules/autocompleteFilter/clinic';

const DEFAULT_PATIENT_FILTER = forms.patientFilterOptions[0];
const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];
const INTERACTION_STATUS_FILTER = [
  { value: undefined, label: 'All' },
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];

const Toolbar = ({ setFilters, filters, timeRanges }) => {
  const onboardingStatuses = forms.patientStatuses;

  const statusOptions = useMemo(
    () => [
      { value: 'only_onboarding_flow', label: 'All' },
      ...onboardingStatuses,
    ],
    [],
  );

  const statusValue = (statusName) => {
    const value = statusOptions.find((element) => element.value === statusName);
    return value;
  };

  return (
    <Row>
      <Col xl="2" lg="3" md="4" sm="6" xs="12">
        <strong>Time Range</strong>
        <Select
          options={timeRanges}
          defaultValue={timeRanges[0]}
          classNamePrefix="select-type"
          onChange={({ value: [startDate, endDate] }) =>
            setFilters({ startDate, endDate })
          }
        />
      </Col>
      <Col xl="2" lg="3" md="4" sm="6" xs="12">
        <strong>Interaction Status</strong>
        <Select
          options={INTERACTION_STATUS_FILTER}
          defaultValue={INTERACTION_STATUS_FILTER[0]}
          classNamePrefix="select-type"
          onChange={({ value }) => setFilters({ interactionStatus: value })}
        />
      </Col>
      <Col xl="2" lg="3" md="4" sm="6" xs="12">
        <strong>Clinic</strong>
        <AutoCompleteClinics
          filter={DEFAULT_CLINIC_FILTER}
          handleClick={({ value }) => {
            setFilters({ clinicGuid: value });
          }}
        />
      </Col>
      <Col xl="2" lg="3" md="4" sm="6" xs="12">
        <strong>Doctor</strong>
        <AutoCompleteDoctor
          filter={DEFAULT_PATIENT_FILTER}
          status="active"
          handleClick={({ value }) => {
            setFilters({ doctorGuid: value });
          }}
        />
      </Col>
      <Col xl="2" lg="3" md="4" sm="6" xs="12">
        <strong>Patient Status</strong>
        <Select
          options={statusOptions}
          defaultValue={statusOptions[1]}
          classNamePrefix="select-type"
          value={statusValue(filters.status)}
          onChange={({ value }) => setFilters({ patientStatus: value })}
        />
      </Col>
    </Row>
  );
};

Toolbar.propTypes = {
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.object,
  timeRanges: PropTypes.array,
};

export default Toolbar;
